import React from 'react'
import { connect } from 'react-redux'
import { WEB_TYPES } from '../Redux/NavigationRedux'
import I18n from 'i18n-react'

class InitContainer extends React.Component {

	render () {

		let calcType = 'groundingCalc'
		switch (this.props.webType) {
			case WEB_TYPES.LIABILITY:
				calcType = 'liabilityCalc'
				break;
			case WEB_TYPES.HOUSEHOLD:
				calcType = 'houseHoldCalc'
				break;
		}

		return (
		<div className='mt-4 mb-2'>
			<h2>{I18n.translate('general.initTitle')}</h2>
			<p>{I18n.translate('general.initText')}</p>
			<h2>{I18n.translate('general.' + calcType)}</h2>
		</div>
		)
	}
}

const mapStateToProps = state => ({
	webType: state.navigation.webType
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(InitContainer)
